/**
 * Domain Redirect Component - Ensures users are always on canonical domain
 * Fixes Google Search Console duplicate content issues
 * SSR-compatible with proper guards
 */
import { useEffect } from 'react';
import { redirectToCanonicalDomain } from '../utils/seoUtils';

const DomainRedirect = ({ children }) => {
  useEffect(() => {
    // Only run on client-side after hydration
    if (typeof window !== 'undefined') {
      // Small delay to ensure full hydration
      setTimeout(() => {
        redirectToCanonicalDomain();
      }, 100);
    }
  }, []);

  return children;
};

export default DomainRedirect;
